var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-Footer-Desktop",
    transform: "translate(-1559.000000, -140.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(1391.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(168.000000, 3.028346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02493775,4.54334419 C9.02493775,7.05259529 7.00463513,9.0868416 4.51239226,9.0868416 C2.0201494,9.0868416 0,7.0532082 0,4.54334419 C0,2.03348018 2.02030262,0 4.51239226,0 C7.0044819,0 9.02493775,2.03409309 9.02493775,4.54334419 M13.9752538,4.54334419 C13.9752538,6.90549703 12.9650259,8.82022601 11.718981,8.82022601 C10.4729362,8.82022601 9.46270829,6.90488412 9.46270829,4.54334419 C9.46270829,2.18180425 10.4729362,0.266462364 11.718981,0.266462364 C12.9650259,0.266462364 13.9752538,2.18180425 13.9752538,4.54334419 M16,4.54334419 C16,6.65972036 15.6446658,8.37525378 15.2064355,8.37525378 C14.7682053,8.37525378 14.4128711,6.65910745 14.4128711,4.54334419 C14.4128711,2.42758092 14.7682053,0.711434591 15.2065888,0.711434591 C15.6449722,0.711434591 16,2.42712124 16,4.54334419",
    id: "path857"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.051211c747ed77e10da9d4f8bfbddbc2.svg";
export { ForwardRef as ReactComponent };